import styled from 'styled-components';

export const ReadStatusSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
